/**
 * Maps a SportsEnum value (e.g. 'PICKLEBALL', 'PLATFORM_TENNIS') to a human-readable
 * label. Accepts a raw string so callers don't need to import the enum, and falls back
 * to a sensible default when the sport is missing/unknown.
 */
const SPORT_LABELS: Record<string, string> = {
  PICKLEBALL: 'Pickleball',
  TENNIS: 'Tennis',
  PADEL: 'Padel',
  PLATFORM_TENNIS: 'Platform Tennis',
};

export const getSportLabel = (sport?: string | null, fallback = 'Pickleball'): string =>
  (sport && SPORT_LABELS[sport]) || fallback;
